import { Radio, Shield, Skull, Utensils, Timer, Calculator, Gamepad2, type LucideIcon } from 'lucide-react';

export type GameMode =
  | 'walkie' | 'dominations' | 'mrtvoliste' | 'hostina' | 'stopky' | 'pocitadlo';

interface ModeMeta {
  icon: LucideIcon;
  /** Mantine barva pro odlišení módu v seznamech. */
  color: string;
  label: string;
}

const META: Record<GameMode, ModeMeta> = {
  walkie:      { icon: Radio,      color: 'forest', label: 'Vysílačky' },
  dominations: { icon: Shield,     color: 'blue',   label: 'Dominations' },
  mrtvoliste:  { icon: Skull,      color: 'red',    label: 'Mrtvoliště' },
  hostina:     { icon: Utensils,   color: 'orange', label: 'Hostina' },
  stopky:      { icon: Timer,      color: 'grape',  label: 'Stopky' },
  pocitadlo:   { icon: Calculator, color: 'pink',   label: 'Počítadlo' },
};

const FALLBACK: ModeMeta = { icon: Gamepad2, color: 'gray', label: 'Hra' };

export function modeMeta(id?: string | null): ModeMeta {
  return (id && META[id as GameMode]) || FALLBACK;
}
